import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_LOCATION_LISTING,
    ADD_LOCATION,
    UPDATE_LOCATION,
    DELETE_LOCATION,
    EXPORT_LOCATION,
    GET_LOCATION_DETAILS,
} from "./actionTypes.js";

import {
    getLocationListingSuccess,
    getLocationListingFail,
    getLocationDetailsSuccess,
    createLocationSuccess,
    createLocationFail,
    updateLocationSuccess,
    updateLocationFail,
    deleteLocationSuccess,
    deleteLocationFail,
    exportLocationSuccess,
    exportLocationFail,
    getLocationDetailsFail,
} from "./actions.js";

import {
    locationListingApi,
    locationDetailsApi,
    addLocationApi,
    updateLocationApi,
    deleteLocationApi,
    exportLocationApi,
} from "./locationApi.js";

function* fetchLocationListing({ payload }) {
    try {
        const response = yield call(locationListingApi, payload);
        yield put(getLocationListingSuccess(response));
    } catch (error) {
        yield put(getLocationListingFail(error));
    }
}

function* fetchLocationDetail({ payload }) {
    try {
        const response = yield call(locationDetailsApi, payload);
        yield put(getLocationDetailsSuccess(response));
    } catch (error) {
        yield put(getLocationDetailsFail(error));
    }
}

function* createLocation({ payload }) {
    try {
        const response = yield call(addLocationApi, payload);
        yield put(createLocationSuccess(response));
    } catch (error) {
        yield put(createLocationFail(error));
    }
}

function* updateLocation({ payload }) {
    try {
        const response = yield call(updateLocationApi, payload);
        yield put(updateLocationSuccess(response));
    } catch (error) {
        yield put(updateLocationFail(error));
    }
}

function* deleteLocation({ payload }) {
    try {
        const response = yield call(deleteLocationApi, payload);
        yield put(deleteLocationSuccess(response));
    } catch (error) {
        yield put(deleteLocationFail(error));
    }
}

function* exportLocation({ payload }) {
    try {
        const response = yield call(exportLocationApi, payload);
        yield put(exportLocationSuccess(response));
    } catch (error) {
        yield put(exportLocationFail(error));
    }
}

function* LocationSaga() {
    yield takeEvery(GET_LOCATION_LISTING, fetchLocationListing);
    yield takeEvery(GET_LOCATION_DETAILS, fetchLocationDetail);
    yield takeEvery(ADD_LOCATION, createLocation);
    yield takeEvery(UPDATE_LOCATION, updateLocation);
    yield takeEvery(DELETE_LOCATION, deleteLocation);
    yield takeEvery(EXPORT_LOCATION, exportLocation);

}

export default LocationSaga
